<template>

<footer class="footer">

  <!-- TOP -->
  <div class="container footer-grid">

    <!-- ENTREPRISE -->
    <div class="footer-col footer-brand">

      <div class="footer-brand-top">

        <img
          src="@/assets/logo_groupeviras.jpeg"
          alt="Groupe VIRAS"
          class="footer-logo-img"
        />

        <h3 class="footer-logo">
          Groupe VIRAS
        </h3>

      </div>

  <p class="footer-description">
    {{ site.description }}
  </p>

      <div v-if="reseaux.length" class="footer-socials">

        <a
          v-for="r in reseaux"
          :key="r.nom"
          :href="r.url"
          target="_blank"
          rel="noopener"
          :aria-label="r.nom"
        >
          <i :class="`bi bi-${r.nom}`"></i>
        </a>

      </div>

    </div>

    <!-- FILIALES -->
    <div class="footer-col">

      <h4 class="footer-title">
        Nos Filiales
      </h4>

      <ul class="footer-links">

        <li>
          <router-link to="/filiales/louga-voyages">
            <i class="bi bi-airplane"></i>
            Louga Voyages
          </router-link>
        </li>

        <li>
          <router-link to="/filiales/saveur-deco">
            <i class="bi bi-cup-hot"></i>
            Saveurs N'Deco
          </router-link>
        </li>

        <li>
          <router-link to="/filiales/lamien-consulting">
            <i class="bi bi-briefcase"></i>
            Lamien Consulting
          </router-link>
        </li>

        <li>
          <router-link to="/filiales/clinique-demassi">
            <i class="bi bi-hospital"></i>
            Clinique DemAssi
          </router-link>
        </li>

        <li>
          <router-link to="/filiales/baraka-boutique">
            <i class="bi bi-bag"></i>
            Boutique Baraka
          </router-link>
        </li>

        <li>
          <router-link to="/filiales/pool-formation">
            <i class="bi bi-mortarboard"></i>
            Pool Formation
          </router-link>
        </li>

        <li>
          <router-link to="/filiales/centre-almanassik">
            <i class="bi bi-building"></i>
            Centre Almanassik
          </router-link>
        </li>
        <li>
  <router-link to="/filiales/maison-viras">
    <i class="bi bi-gem"></i>
    Maison VIRAS
  </router-link>
</li>

<li>
  <router-link to="/filiales/viras-technologies">
    <i class="bi bi-cpu"></i>
    VIRAS Technologies
  </router-link>
</li>

      </ul>

    </div>

    <!-- NAVIGATION -->
    <div class="footer-col">

      <h4 class="footer-title">
        Navigation
      </h4>

      <ul class="footer-links">

        <li>
          <router-link to="/">
            <i class="bi bi-house-door"></i>
            Accueil
          </router-link>
        </li>

        <li>
          <router-link to="/groupe">
            <i class="bi bi-buildings"></i>
            Le Groupe
          </router-link>
        </li>

        <li>
          <router-link to="/services">
            <i class="bi bi-grid"></i>
            Services
          </router-link>
        </li>

        <li>
          <router-link to="/contact">
            <i class="bi bi-envelope"></i>
            Contact
          </router-link>
        </li>

      </ul>

    </div>

    <!-- CONTACT -->
    <div class="footer-col">

      <h4 class="footer-title">
        Contact
      </h4>

      <div v-if="site.adresse" class="contact-item">
        <i class="bi bi-geo-alt-fill"></i>
        <span>{{ site.adresse }}</span>
      </div>

      <a v-if="site.telephone" :href="telLink(site.telephone)" class="contact-item">
        <i class="bi bi-telephone-fill"></i>
        <span>{{ site.telephone }}</span>
      </a>

      <a v-if="site.email" :href="`mailto:${site.email}`" class="contact-item">
        <i class="bi bi-envelope-fill"></i>
        <span>{{ site.email }}</span>
      </a>

      <div v-if="site.horaires" class="contact-item">
        <i class="bi bi-clock-fill"></i>
        <span>{{ site.horaires }}</span>
      </div>

      <router-link
        to="/contact"
        class="footer-contact-btn"
      >
        <i class="bi bi-send-fill"></i>
        Nous contacter
      </router-link>

    </div>

  </div>

  <!-- BOTTOM -->
  <div class="footer-bottom">

    <div class="container footer-bottom-content">

      <p>
        © {{ annee }} {{ site.nomSite }} — Tous droits réservés
      </p>

      <div class="footer-bottom-links">

        <a href="#">
          Mentions légales
        </a>

        <a href="#">
          Politique de confidentialité
        </a>

      </div>

    </div>

  </div>

</footer>

</template>

<script setup>
import { computed } from "vue";
import { useSite, telLink } from "@/composables/useSite";

// Coordonnées et réseaux sociaux gérés depuis l'admin (Paramètres du site)
const site = useSite();
const annee = new Date().getFullYear();

const ordre = ["facebook", "instagram", "linkedin", "tiktok", "youtube"];
const reseaux = computed(() =>
  ordre
    .filter((nom) => site.reseaux && site.reseaux[nom])
    .map((nom) => ({ nom, url: site.reseaux[nom] }))
);
</script>

<style scoped>

/* FOOTER */

.footer{
  position:relative;
  background:
    linear-gradient(
      135deg,
      #081c2c 0%,
      #0F2B45 50%,
      #163d61 100%
    );
  color:white;
  margin-top:100px;
  overflow:hidden;
}

/* TOP */

.footer-grid{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
  gap:50px;
  padding:90px 0 60px;
  position:relative;
  z-index:2;
}

/* BRAND */

.footer-brand-top{
  display:flex;
  align-items:center;
  gap:15px;
  margin-bottom:20px;
}

.footer-logo-img{
  width:60px;
  height:60px;
  border-radius:50%;
  object-fit:cover;
  border:3px solid #F0C95C;
}

.footer-logo{
  font-size:1.7rem;
  font-weight:800;
  color:#F0C95C;
}

.footer-description{
  line-height:1.9;
  color:#d1d5db;
  margin-bottom:25px;
}

/* TITLES */

.footer-title{
  font-size:1.2rem;
  font-weight:700;
  color:#F0C95C;
  margin-bottom:25px;
  position:relative;
}

.footer-title::after{
  content:"";
  position:absolute;
  left:0;
  bottom:-8px;
  width:50px;
  height:3px;
  border-radius:10px;
  background:#F0C95C;
}

/* LINKS */

.footer-links{
  list-style:none;
  padding:0;
  margin:0;
}

.footer-links li{
  margin-bottom:14px;
}

.footer-links a{
  display:flex;
  align-items:center;
  gap:10px;
  color:#e5e7eb;
  text-decoration:none;
  transition:0.3s ease;
  font-size:0.96rem;
}

.footer-links a i{
  color:#F0C95C;
}

.footer-links a:hover{
  color:#F0C95C;
  transform:translateX(6px);
}

/* CONTACT */

.contact-item{
  display:flex;
  align-items:flex-start;
  gap:12px;
  margin-bottom:18px;
  color:#e5e7eb;
  line-height:1.6;
}

.contact-item i{
  color:#F0C95C;
  margin-top:3px;
}

/* BUTTON */

.footer-contact-btn{
  display:inline-flex;
  align-items:center;
  gap:10px;
  margin-top:15px;
  background:#F0C95C;
  color:#0F2B45;
  padding:14px 24px;
  border-radius:50px;
  text-decoration:none;
  font-weight:700;
  transition:0.3s ease;
}

.footer-contact-btn:hover{
  transform:translateY(-4px);
  background:white;
}

/* SOCIALS */

.footer-socials{
  display:flex;
  gap:15px;
}

.footer-socials a{
  width:42px;
  height:42px;
  border-radius:50%;
  background:rgba(255,255,255,0.08);
  border:1px solid rgba(255,255,255,0.1);
  color:#F0C95C;
  display:flex;
  align-items:center;
  justify-content:center;
  text-decoration:none;
  transition:0.3s ease;
  font-size:1rem;
}

.footer-socials a:hover{
  background:#F0C95C;
  color:#0F2B45;
  transform:translateY(-5px);
}

/* BOTTOM */

.footer-bottom{
  border-top:1px solid rgba(255,255,255,0.08);
  padding:25px 0;
  background:rgba(0,0,0,0.15);
}

.footer-bottom-content{
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:20px;
  flex-wrap:wrap;
}

.footer-bottom p{
  color:#d1d5db;
  font-size:0.92rem;
}

.footer-bottom-links{
  display:flex;
  gap:20px;
}

.footer-bottom-links a{
  color:#d1d5db;
  text-decoration:none;
  transition:0.3s;
  font-size:0.92rem;
}

.footer-bottom-links a:hover{
  color:#F0C95C;
}

/* RESPONSIVE */

@media(max-width:768px){

  .footer{
    text-align:center;
  }

  .footer-grid{
    gap:45px;
    padding:70px 0 50px;
  }

  .footer-brand-top{
    justify-content:center;
  }

  .footer-title::after{
    left:50%;
    transform:translateX(-50%);
  }

  .footer-links a{
    justify-content:center;
  }

  .contact-item{
    justify-content:center;
  }

  .footer-socials{
    justify-content:center;
  }

  .footer-bottom-content{
    flex-direction:column;
  }

}

</style>